import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { controlValueIsSameValidator } from '../../common/validators/control-value-is-same';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

    public error: string;
    public resetForm: FormGroup;

    private token: string;

    constructor(private readonly route: ActivatedRoute,
                private readonly authService: AuthService,
                private readonly fb: FormBuilder,
                private readonly router: Router) { }

    public ngOnInit(): void {
        this.resetForm = this.fb.group({
            password: ['', Validators.required],
            confirmPassword: ['', Validators.required]
        });

        this.resetForm.get('confirmPassword').setValidators([Validators.required, controlValueIsSameValidator(this.resetForm.get('password'))]);

        this.route.queryParamMap.subscribe(queryParms => this.token = queryParms.get('token'));
    }

    public onSubmit() {
        this.error = undefined;
        this.authService.resetPassword({resetToken: this.token, password: this.resetForm.get('password').value})
            .subscribe(() => this.router.navigate(['/login']), () => this.error = 'Password reset was not successful!');
    }

}
